import { init, type BrowserOptions } from '@sentry/browser';
import { getSentryInitMetadata, isSentryEnabled } from '@theia-lved-core/common/sentry-config';

export const initializeFrontendSentry = (): void => {
    if (!isSentryEnabled()) return;

    const options: BrowserOptions = getSentryInitMetadata();
    init(options);
};
